import { z } from "zod";
import { URL_ARRAY_SEPARATOR, URL_ARRAY_SEPARATOR_LEGACY_COMMA } from "./constants";

export const array = <T extends z.ZodTypeAny>(schema: T) =>
  z.preprocess((val, ctx) => {
    if (Array.isArray(val)) {
      return val;
    } else if (typeof val === "string") {
      // Support multiple separators: hyphen (preferred) and comma (legacy)
      let separator = URL_ARRAY_SEPARATOR_LEGACY_COMMA; // default fallback
      if (val.includes(URL_ARRAY_SEPARATOR)) separator = URL_ARRAY_SEPARATOR;
      return val.split(separator).filter(Boolean);
    } else {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Not string or array given "${JSON.stringify(val)}"`,
        fatal: true,
      });

      return z.NEVER;
    }
  }, z.array(schema));

export const number = z.preprocess((val) => {
  if (typeof val === "number") {
    return val;
  } else if (typeof val === "string" && val !== "") {
    return Number(val);
  }
}, z.number());

export const string = z.preprocess((val, ctx) => {
  if (typeof val === "number" && !Number.isNaN(val)) {
    return val.toString();
  } else if (typeof val === "string") {
    return val;
  }

  ctx.addIssue({
    code: z.ZodIssueCode.custom,
    message: `Bad string "${val}"`,
    fatal: true,
  });

  return z.NEVER;
}, z.string());

export const boolean = z.preprocess((val, ctx) => {
  if (typeof val === "boolean") {
    return val;
  } else if (typeof val === "string") {
    return val.toLowerCase() === "true";
  }

  ctx.addIssue({
    code: z.ZodIssueCode.custom,
    message: `Bad string "${val}"`,
    fatal: true,
  });

  return z.NEVER;
}, z.boolean());
